import { useSelector } from 'react-redux';
import { Checkbox, ICheckboxOptions } from '../../../../../component';
import {
  createMeanFamilyIncomeMap,
  handleCheckbox,
  hasAverageIncomePolygons,
} from '../../controllers/dataLayers.controller';
import { RootState } from '../../../../../reducer';
import { useCallback, useEffect } from 'react';

function AverageIncomeSwitch() {
  const { dataLayers } = useSelector(
    (state: RootState) => state.dataLayersState
  );
  const checked = useCallback(() => {
    return dataLayers.averageIncome.options.some((option) => option.checked);
  }, [dataLayers.averageIncome.options]);

  useEffect(() => {
    if (!hasAverageIncomePolygons() && checked()) {
      createMeanFamilyIncomeMap();
    }
  }, [checked]);

  return (
    <Checkbox
      cy={'DataLayerAverageIncome'}
      action={(event) =>
        handleCheckbox(
          event as ICheckboxOptions,
          'Renda média',
          'averageIncome'
        )
      }
      name={dataLayers.averageIncome.id}
      checked={checked()}
      type="switch"
    />
  );
}

export default AverageIncomeSwitch;
